/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-04-16 19:05:50
 * @LastEditors: changfeng
 * @LastEditTime: 2024-06-25 10:27:49
 */
export default {
	"Automated rule turned on": "Automated rule turned on",
	"Automated rule turned off": "Automated rule turned off",
	"message.success": "Success",
	"message.error": "Error",
	"message.pending": "Creating",
	"message.successfully": "Created Sucessfully",
	"message.update.success": "Update success",
	"message.campaign.No ad groups were able to be copied.": "No ad groups were able to be copied.",
	"message.campaign.No ads in this ad group": "No ads in this ad group",
	"message.tip": "Tips",
	"message.adgroup.Template.name": "Please Input Template Name",

	"message.create.Ad.material.info": "Please choose at least one Ad Material",
	"message.create.Ad.validate.information": "Please verify the form information",
	"message.create.Ad.identity.choose.information": "Please choose a identity",
	"message.create.Ad.identity.adText": "Enter text for your ad (The length ranges from 1 to 100)",
	"message.create.Ad.identity.landingPage": "Please enter a landingPage url",

	"message.adParams.check.landingPage.pre": "Please add landingPage for the {{count}} AD",
	"message.adParams.check.landingPage.last": "AD",
	"message.adParams.check.identity.pre": "Please add identity for the {{count}} AD",
	"message.adParams.check.identity.last": "AD",
	"message.adParams.check.adText.pre": "Please add adText for the {{count}} AD",
	"message.adParams.check.product.pre": "Please add product for the {{count}} AD",
	"message.adParams.check.adText.last": "AD",

	"message.create.Ad.identity.choose an operation material": "Please choose an operation material",

	"message.create.adgroup.placement.error": "Please choose at least one placement",
	"message.create.adgroup.region.error": "Please choose region",
	"message.create.adgroup.pixel.error": "Please choose pixel",
	"message.create.adgroup.startTime.error": "Please set start time",

	"message.create.Ad.identity.displayName": "Please enter the identity display name",

	"message.adParams.check.product": "please choose product",
	"message.adParams.check.product.type": "please choose the product",

	"message.creating": "Creating",
	"message.adgroup.creating": "Creating adgroup",
	"message.adgroup.creating.failed": "Adgroup created failed",
	"message.adgroup.creating.success": "Adgroup created success",

	"message.ad.creating": "Creating Ad",
	"message.ad.creating.failed": "Ad created failed",
	"message.ad.creating.success": "Ad created success",

	"message.upgrade.subscription.plan.success": "Request submitted successfully. You can check the result in the Payment History.",

	"message.copyadgroup.success": "Copy ad group success"
};
